import { CardSvg } from '@/play/cardSvg'

/** Home card art: a drop falling stretched, one splatted with its ripple, one round at rest. */
export function SplatCardArt() {
  return (
    <CardSvg bg="#ffe1d6">
      <ellipse cx="160" cy="168" rx="150" ry="34" fill="#f3eee4" />
      {/* ripple under the splat */}
      <ellipse cx="170" cy="160" rx="62" ry="14" fill="none" stroke="#2ec4ff" strokeWidth="4" opacity="0.45" />
      <ellipse cx="170" cy="160" rx="84" ry="19" fill="none" stroke="#2ec4ff" strokeWidth="3" opacity="0.2" />
      {/* falling drop, stretched along its velocity */}
      <ellipse cx="170" cy="58" rx="15" ry="26" fill="#2ec4ff" />
      <ellipse cx="164" cy="50" rx="4" ry="8" fill="#ffffff" opacity="0.6" />
      <path d="M170 18 v 8 M170 6 v 6" stroke="#2ec4ff" strokeWidth="4" strokeLinecap="round" opacity="0.35" />
      {/* the splat */}
      <ellipse cx="170" cy="150" rx="36" ry="13" fill="#ff5c8a" />
      <ellipse cx="160" cy="145" rx="10" ry="3" fill="#ffffff" opacity="0.55" />
      {/* one at rest, round */}
      <ellipse cx="78" cy="148" rx="24" ry="20" fill="#ffc93c" />
      <ellipse cx="71" cy="140" rx="6" ry="5" fill="#ffffff" opacity="0.55" />
      <ellipse cx="250" cy="152" rx="20" ry="16" fill="#7ad86b" />
      <ellipse cx="244" cy="146" rx="5" ry="4" fill="#ffffff" opacity="0.55" />
    </CardSvg>
  )
}
